const toProject = (data) => {
  return {
    project_id : data.project_id,
    name       : data.name,
    company_id : data.company_id,
    uvodni_list: {
      sections: {
        1: {
          section_number: data.recital.building.section_number,
          vrsta_objekta: data.recital.building.vrsta_objekta,
          kraj_gradnje: data.recital.building.kraj_gradnje,
          kraj_za_vreme: data.recital.building.kraj_za_vreme,
          vrsta_gradnje: data.recital.building.vrsta_gradnje
        },
        2: {
          section_number: data.recital.investor.section_number,
          naziv: data.recital.investor.naziv
        },
        3: {
          section_number: data.recital.contractor.section_number,
          naziv: data.recital.contractor.naziv,
          odgovorni: data.recital.contractor.odgovorni,
          vodja_gradbisca: data.recital.contractor.vodja_gradbisca,
          vodja_posameznih_del: data.recital.contractor.vodja_posameznih_del
        },
        4: {
          section_number: data.recital.project_for_building_permit.section_number,
          stevilka_in_datum: data.recital.project_for_building_permit.stevilka_in_datum
        },
        5: {
          section_number: data.recital.building_permit.section_number,
          izdajatelj: data.recital.building_permit.izdajatelj,
          stevilka_in_datum: data.recital.building_permit.stevilka_in_datum
        },
        6: {
          section_number: data.recital.execution_project.section_number,
          stevilka_in_datum: data.recital.execution_project.stevilka_in_datum
        },
        7: {
          section_number: data.recital.supervisor.section_number,
          naziv: data.recital.supervisor.naziv,
          odgovorna_oseba: data.recital.supervisor.odgovorna_oseba,
          odgovorna_oseba_posameznih_del: data.recital.supervisor.odgovorna_oseba_posameznih_del
        },
        8: {
          section_number: data.recital.archeology.section_number,
          naziv: data.recital.archeology.naziv,
          arheolog: data.recital.archeology.arheolog
        },
        9: {
          section_number: data.recital.responsibilities.section_number,
          odgovorni_gradbenega_dnevnika: data.recital.responsibilities.odgovorni_gradbenega_dnevnika,
          odgovorni_obracunskih_mer: data.recital.responsibilities.odgovorni_obracunskih_mer
        },
        10: {
          section_number: data.recital.documentation.section_number,
          stevilka_varnostnega_nacrta: data.recital.documentation.stevilka_varnostnega_nacrta,
          izvajalec: data.recital.documentation.izvajalec,
          koordinator_za_varnost: data.recital.documentation.koordinator_za_varnost
        },
        11: {
          section_number: data.recital.introductions.section_number,
          datum: data.recital.introductions.datum,
          podpisi: data.recital.introductions.podpisi
        }
      }
    }
  };
}

const toSiteLog = (data) => {
  return {
    project_id: data.project_id,
    company_id: data.company_id,
    sequence: data.sequence,
    date: data.date,
    delovni_cas: {
      od: data.delovni_cas.od,
      do: data.delovni_cas.do
    },
    vremenske_razmere: {
      0: {
        merjeno_ob: data.vremenske_razmere.first.merjeno_ob,
        vreme: data.vremenske_razmere.first.vreme,
        temperatura: data.vremenske_razmere.first.temperatura,
        padavine_mm: data.vremenske_razmere.first.padavine_mm,
        vodostaj_cm: data.vremenske_razmere.first.vodostaj_cm,
        hitrost_vetra_ms: data.vremenske_razmere.first.hitrost_vetra_ms,
        drugi_pogoji: data.vremenske_razmere.first.drugi_pogoji
      },
      1: {
        merjeno_ob: data.vremenske_razmere.second.merjeno_ob,
        vreme: data.vremenske_razmere.second.vreme,
        temperatura: data.vremenske_razmere.second.temperatura,
        padavine_mm: data.vremenske_razmere.second.padavine_mm,
        vodostaj_cm: data.vremenske_razmere.second.vodostaj_cm,
        hitrost_vetra_ms: data.vremenske_razmere.second.hitrost_vetra_ms,
        drugi_pogoji: data.vremenske_razmere.second.drugi_pogoji
      },
      2: {
        merjeno_ob: data.vremenske_razmere.third.merjeno_ob,
        vreme: data.vremenske_razmere.third.vreme,
        temperatura: data.vremenske_razmere.third.temperatura,
        padavine_mm: data.vremenske_razmere.third.padavine_mm,
        vodostaj_cm: data.vremenske_razmere.third.vodostaj_cm,
        hitrost_vetra_ms: data.vremenske_razmere.third.hitrost_vetra_ms,
        drugi_pogoji: data.vremenske_razmere.third.drugi_pogoji
      }
    },
    delavci: {
      vodstvo: {
        izvajalci: data.delavci.vodstvo.izvajalci,
        najeti: data.delavci.vodstvo.najeti,
        kooperanti: data.delavci.vodstvo.kooperanti
      },
      gradbena_dela: {
        izvajalci: data.delavci.gradbena_dela.izvajalci,
        najeti: data.delavci.gradbena_dela.najeti,
        kooperanti: data.delavci.gradbena_dela.kooperanti
      },
      obrtniki: {
        izvajalci: data.delavci.obrtniki.izvajalci,
        najeti: data.delavci.obrtniki.najeti,
        kooperanti: data.delavci.obrtniki.kooperanti
      },
      instalaterji: {
        izvajalci: data.delavci.instalaterji.izvajalci,
        najeti: data.delavci.instalaterji.najeti,
        kooperanti: data.delavci.instalaterji.kooperanti
      },
      drugi: {
        izvajalci: data.delavci.drugi.izvajalci,
        najeti: data.delavci.drugi.najeti,
        kooperanti: data.delavci.drugi.kooperanti
      }
    },
    stroji: {
      izvajalec: data.stroji.izvajalec,
      drugi: data.stroji.drugi
    },
    sporocila_narocniku: data.sporocila_narocniku,
    sestavil: data.sestavil,
    odgovorni: data.odgovorni,
    nadzorni: data.nadzorni,
    dopolnilni_del: data.dopolnilni_del,
    opombe_in_zahteve_odgovornega_vodje: data.opombe_in_zahteve_odgovornega_vodje,
    opombe_in_zahteve_inspekcijskih_sluzb: data.opombe_in_zahteve_inspekcijskih_sluzb,
    opombe_in_zahteve_projektantov: data.opombe_in_zahteve_projektantov,
    opombe_in_zahteve_soglasodajalcev: data.opombe_in_zahteve_soglasodajalcev,
    opombe_ali_odgovori_izvajalca_del: data.opombe_ali_odgovori_izvajalca_del,

    attachments: data.attachments,

    // Signature images
    signature_sestavil: data.signature_sestavil,
    signature_odgovorni: data.signature_odgovorni,
    signature_nadzorni: data.signature_nadzorni,
  };
}

const toImage = (data) => {
  return {
    ...data,
    thumbs: {
      256: [data.thumbs.find(t => t.size = 256).url],
      1024: [data.thumbs.find(t => t.size = 1024).url],
    }
  }
}

export {
  toProject,
  toSiteLog,
  toImage
}
